import { publicClient, privateClient } from "../../configs/axiosConfig";

const userEndpoints = {
  signin: "v2/operator/login",
  updateProfile: "v2/operator/operatorUpdate",
  passwordUpdate: "v2/operator/password/update",

  getInfo: "v1/user/info",
  getAllUsers: "v1/user/allUsers",
};

const userApi = {
  signin: async ({ username, password }) => {
    try {
      const response = await publicClient.post(userEndpoints.signin, {
        username,
        password,
      });

      return { response, err: null };
    } catch (err) {
      console.error("❌ Sign in API error:", err.response || err.message);

      return {
        response: null,
        err: err.response?.data || { message: err.message },
      };
    }
  },
  signup: async ({
    username,
    password,
    confirmPassword,
    displayName,
    photo,
  }) => {
    try {
      const response = await publicClient.post(userEndpoints.signup, {
        username,
        password,
        confirmPassword,
        displayName,
        photo,
      });

      return { response };
    } catch (err) {
      return { err };
    }
  },
  getInfo: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getInfo);

      return { response };
    } catch (err) {
      return { err };
    }
  },
  getAllUsers: async () => {
    try {
      const response = await privateClient.get(userEndpoints.getAllUsers);
      return { response };
    } catch (err) {
      console.error("Error fetching all users:", err);
      return { err };
    }
  },
  updateProfile: async (data) => {
    try {
      const response = await privateClient.patch(
        userEndpoints.updateProfile,
        data,
      );
      console.log("response api", response);
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data?.message || "Profile update failed");
    }
  },
  passwordUpdate: async ({ oldPassword, newPassword, confirmNewPassword }) => {
    try {
      const response = await privateClient.patch(userEndpoints.passwordUpdate, {
        oldPassword,
        newPassword,
      });

      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default userApi;
